import Vue from 'vue';
import { PtButton } from '@pathao/ui-components/esm/Button';
import { PtCollapsibleSidebar } from '@pathao/ui-components/esm/SidebarV1';
import { PtViewTable } from '@pathao/ui-components/esm/Table';
import { PtPagination } from '@pathao/ui-components/esm/Pagination';
import { PtPopover } from '@pathao/ui-components/esm/Popover';
import { PtLoader } from '@pathao/ui-components/esm/Loader';

import {
  PtForm,
  PtFormGroup,
  PtFormInput,
} from '@pathao/ui-components/esm/FormComponents';

[
  PtButton,
  PtCollapsibleSidebar,
  PtViewTable,
  PtPagination,
  PtPopover,
  PtLoader,
  PtForm,
  PtFormGroup,
  PtFormInput,
].forEach((component) => {
  const componentName = component.name;
  Vue.component(componentName, component.default || component);
});
